<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'app',
    methods: {
      // ...mapActions(['updateUserClass'])
    },
    created () {
      console.log('created-cicd')
      // this.updateUserClass()
    }
  }
</script>
<style lang="scss">
  @import './styles/index.scss'; // 全局自定义的css样式
</style>
